import { render } from "./ResumoGeralPage.vue?vue&type=template&id=f7e7c53c"
import script from "./ResumoGeralPage.vue?vue&type=script&lang=js"
export * from "./ResumoGeralPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__